// Saudi public-university roster used in the onboarding dropdown.
// Source: `data/tenders-structured.json` filtered to is_tvtc=false, distinct
// entities. Sort order = total tender value SAR descending (the workshop
// reveal celebrates the value leader). 28 universities, no TVTC.
//
// `key` is the entity_en string the worker uses to record predictions —
// must match the `entity_en` field in the tender corpus exactly so the
// reveal-data endpoint and the prediction histogram line up.

export type University = {
  key: string;        // entity_en (corpus identifier)
  en: string;         // short English label for the dropdown
  ar: string;         // Arabic label for the dropdown
};

export const UNIVERSITIES: University[] = [
  { key: 'Imam Abdulrahman Bin Faisal University (IAU)', en: 'Imam Abdulrahman Bin Faisal University (IAU)', ar: 'جامعة الإمام عبدالرحمن بن فيصل' },
  { key: 'Imam Mohammad University', en: 'Imam Muhammad Ibn Saud University', ar: 'جامعة الإمام محمد بن سعود' },
  { key: 'King Saud University (KSU)', en: 'King Saud University (KSU)', ar: 'جامعة الملك سعود' },
  { key: 'King Abdulaziz University (KAU)', en: 'King Abdulaziz University (KAU)', ar: 'جامعة الملك عبدالعزيز' },
  { key: 'University of Tabuk', en: 'University of Tabuk', ar: 'جامعة تبوك' },
  { key: 'King Faisal University (KFU)', en: 'King Faisal University (KFU)', ar: 'جامعة الملك فيصل' },
  { key: 'Prince Sattam University (PSAU)', en: 'Prince Sattam University (PSAU)', ar: 'جامعة الأمير سطام بن عبدالعزيز' },
  { key: 'Qassim University', en: 'Qassim University', ar: 'جامعة القصيم' },
  { key: 'King Khalid University (KKU)', en: 'King Khalid University (KKU)', ar: 'جامعة الملك خالد' },
  { key: 'Umm Al-Qura University (UQU)', en: 'Umm Al-Qura University (UQU)', ar: 'جامعة أم القرى' },
  { key: 'Najran University', en: 'Najran University', ar: 'جامعة نجران' },
  { key: 'Princess Nourah University (PNU)', en: 'Princess Nourah University (PNU)', ar: 'جامعة الأميرة نورة بنت عبدالرحمن' },
  { key: 'Shaqra University', en: 'Shaqra University', ar: 'جامعة شقراء' },
  { key: 'Taibah University', en: 'Taibah University', ar: 'جامعة طيبة' },
  { key: 'Islamic University of Madinah', en: 'Islamic University of Madinah', ar: 'الجامعة الإسلامية بالمدينة المنورة' },
  { key: 'Al-Jouf University', en: 'Al-Jouf University', ar: 'جامعة الجوف' },
  { key: 'Majmaah University', en: 'Majmaah University', ar: 'جامعة المجمعة' },
  { key: 'University of Jeddah', en: 'University of Jeddah', ar: 'جامعة جدة' },
  { key: 'University of Hafr Al Batin', en: 'University of Hafr Al Batin', ar: 'جامعة حفر الباطن' },
  { key: 'University of Hail', en: 'University of Hail', ar: 'جامعة حائل' },
  { key: 'Taif University', en: 'Taif University', ar: 'جامعة الطائف' },
  { key: 'King Saud University for Health Sciences (KSAU-HS)', en: 'King Saud University for Health Sciences (KSAU-HS)', ar: 'جامعة الملك سعود بن عبدالعزيز للعلوم الصحية' },
  { key: 'University of Bisha', en: 'University of Bisha', ar: 'جامعة بيشة' },
  { key: 'Northern Borders University (NBU)', en: 'Northern Borders University (NBU)', ar: 'جامعة الحدود الشمالية' },
  { key: 'Jazan University', en: 'Jazan University', ar: 'جامعة جازان' },
  { key: 'Saudi Electronic University (SEU)', en: 'Saudi Electronic University (SEU)', ar: 'الجامعة السعودية الإلكترونية' },
  { key: 'King Fahd University (KFUPM)', en: 'King Fahd University of Petroleum & Minerals (KFUPM)', ar: 'جامعة الملك فهد للبترول والمعادن' },
  { key: 'Al-Baha University', en: 'Al-Baha University', ar: 'جامعة الباحة' },
];

export function findUniversityByKey(key: string): University | null {
  return UNIVERSITIES.find((u) => u.key === key) ?? null;
}
